// intercomArticles.js
'use strict';
import { fromJS } from 'immutable';
import {
  ADD_INTERCOM_ARTICLES,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Intercom articles.
 * @module reducer/intercomArticles
 */
const intercomArticles = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_INTERCOM_ARTICLES:
      return _ADD_INTERCOM_ARTICLES(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Add intercom articles
 * @kind reducer/actionType
 * @name ADD_INTERCOM_ARTICLES
 * @param {object} payload.articles - payload
 * @return {Immutable.Map} New state
 */
const _ADD_INTERCOM_ARTICLES =
  ({ articles }) =>
  state => {
    return state.mergeDeep(articles);
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default intercomArticles;
